import React from 'react';
import { ExternalLink } from 'lucide-react';
import { getSimCardOwner, getSimAdminUrl, normalizeIccid } from '../../../utils/simCardUtils';

// Renders a SIM ICCID as a two-line bubble - the number on top, its owner below:
//   green + clickable (SeeYou Cloud admin) for our own Onomondo cards,
//   gray for cards supplied by the customer.
// Set showIccid={false} for a compact one-line bubble with just the owner
// (e.g. next to an input while editing, where the number is already visible).
const SimCardBadge = ({ iccid, showIccid = true, className = '' }) => {
  const owner = getSimCardOwner(iccid);
  if (!owner) return null;

  const adminUrl = getSimAdminUrl(iccid);
  const shapeClasses = showIccid
    ? 'flex-col items-start px-2.5 py-1 rounded-lg leading-tight'
    : 'items-center gap-1.5 px-2.5 py-0.5 rounded-full';
  const baseClasses = `inline-flex text-xs font-medium whitespace-nowrap ${shapeClasses} ${owner.className} ${className}`;

  const content = (
    <>
      {showIccid && <span className="font-mono tracking-tight">{normalizeIccid(iccid)}</span>}
      <span className="inline-flex items-center gap-1">
        {owner.label}
        {adminUrl && <ExternalLink className="h-3 w-3 flex-shrink-0" />}
      </span>
    </>
  );

  if (adminUrl) {
    return (
      <a
        href={adminUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className={`${baseClasses} hover:bg-green-200 transition-colors`}
        title="Open this SIM card in SeeYou Cloud admin"
      >
        {content}
      </a>
    );
  }

  return (
    <span className={baseClasses} title="SIM card not recognized as a Naviter (Onomondo) SIM">
      {content}
    </span>
  );
};

export default SimCardBadge;
